import { from, of } from 'rxjs';
import { publishReplay, refCount, switchMap } from 'rxjs/operators';
import { get2FactorAuthenticationSettingsConfiguration } from './get2FactorAuthenticationSettingsConfiguration';

export const twoFactorAuthenticationSettingsConfiguration$ = of(1).pipe(
  switchMap(v => from(get2FactorAuthenticationSettingsConfiguration())),
  publishReplay(1),
  refCount()
);
